module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lobby-home-theme clearfix"
  }, [_c('div', {
    staticClass: "lobby-heading-body"
  }, [_c('div', {
    staticClass: "visible-pc"
  }, [_c('div', {
    staticClass: "pc-heading"
  }, [_c('div', {
    staticClass: "swiper-container home-swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.list), function(index) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "lobby-theme-home-header-bg",
      class: 'item' + index
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "layer"
    }, [_c('img', {
      attrs: {
        "src": require("../../../common/assets/img/course/newlayer.png")
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.topic.click()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                          最后更新：" + _vm._s(_vm.currentTime) + " 参与学生：59 学科门类：设计学 课程标签：通识核心课 访问量：" + _vm._s(_vm.visit) + "\n                        ")])])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next home-swiper-button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev home-swiper-button-prev"
  })]), _vm._v(" "), _c('div', {
    staticClass: "lobby-theme-home-menu-bar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('MenuBarView', {
    attrs: {
      "menus": _vm.topic.menus
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "visible-mobile"
  }, [_c('div', {
    staticClass: "mobile-heading"
  }, [_c('div', [_c('img', {
    staticClass: "poster",
    attrs: {
      "src": require("../../../common/assets/img/logo.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/' + _vm.topic.location)
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-circle menu-trigger",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showMenu = !_vm.showMenu
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMenu),
      expression: "!showMenu"
    }],
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('MenuListView', {
    attrs: {
      "menus": _vm.topic.menus
    },
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('router-view')], 1)]), _vm._v(" "), _c('FooterView')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-65555b86"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/theme/HomeTheme.vue
// module id = 995
// module chunks = 1